import OkHand from "@/assets/openmoji/OkHand";
import Navigation from "@/features/navigation/components/Navigation";
import { Link } from "@tanstack/react-router";

import { cn } from "../../lib/utils";
import Title from "../common/Title";
import { buttonVariants } from "../ui/button";

const SuccessPage = () => {
	return (
		<section>
			<div className="md-width">
				<Title words="Success, form submitted!" />
				<OkHand className="flex mx-auto w-32 h-32" />
				<div className="flex flex-col justify-center items-center gap-4 mx-auto p-4 w-full text-center">
					<Link to="/" className={cn(buttonVariants({}))}>
						Next
					</Link>
				</div>
			</div>
		</section>
	);
};
export default SuccessPage;
